import axios from "axios";

// Resolve backend URL at runtime: use the same origin when served from a
// known production custom domain (avoids cross-origin CORS issues entirely).
// Falls back to REACT_APP_BACKEND_URL for preview / Emergent native hosts.
const ENV_BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const SAME_ORIGIN_HOSTS = ["wedocoaching.com", "www.wedocoaching.com"];

function resolveBackendUrl() {
  if (typeof window !== "undefined" && SAME_ORIGIN_HOSTS.includes(window.location.hostname)) {
    return window.location.origin;
  }
  return ENV_BACKEND;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CLIENTS = [
  { name: "Airbus", logo: "/brand/clients/airbus.png" },
  { name: "CERN", logo: "/brand/clients/cern.png" },
  { name: "STMicroelectronics", logo: "/brand/clients/stmicro.png" },
  { name: "Colas", logo: "/brand/clients/colas.png" },
  { name: "SBM Offshore", logo: "/brand/clients/sbm.png" },
  { name: "Petzl", logo: "/brand/clients/petzl.png" },
  { name: "Erborian", logo: "/brand/clients/erborian.png" },
  { name: "Alcyon", logo: "/brand/clients/alcyon.png" },
  { name: "MGI", logo: "/brand/clients/mgi.png" },
  { name: "Point S", logo: "/brand/clients/points.png" },
  { name: "Attestis", logo: "/brand/clients/attestis.png" },
  { name: "Élan Béarnais", logo: "/brand/clients/elan-bearnais.png" },
];

export const NAV = [
  { label: "Accueil", path: "/" },
  { label: "Dirigeants & CODIR", path: "/dirigeants-codir" },
  { label: "Management & Leadership", path: "/management-leadership" },
  { label: "École de Management", path: "/ecole-management" },
  { label: "COO / Conseil opérationnel", path: "/coo-conseil" },
  { label: "Séminaires & Transformation", path: "/seminaires" },
  { label: "PCM", path: "/pcm" },
  { label: "RISE", path: "/rise" },
  { label: "À propos", path: "/a-propos" },
  { label: "Équipe", path: "/equipe" },
  { label: "Blog", path: "/blog" },
  { label: "Contact", path: "/contact" },
];

export const GCAL_IFRAME = "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1JKYU13k0FQCaetCYvBmrQV3f6Hiuo7ap0Fa97rYLQ7AMdfJz6iaVKI4vKqIWyEfqaS95HvEmT?gv=true";

// Unsplash CDN — corporate, managers 30-45, mixed gender
const u = (id, w = 1600) => `https://images.unsplash.com/photo-${id}?w=${w}&q=80&auto=format&fit=crop`;

export const IMG = {
  // William (real)
  hero: "/brand/william_banner.jpg",
  portrait: "/brand/william_portrait.jpg",
  gradient: "/brand/gradient_wedo.jpg",
  // Corporate stock - varied, modern, diverse managers 30-45
  codir: u("1517048676732-d65bc937f952"),       // executive boardroom — dirigeants en discussion
  coo: u("1497215842964-222b430dc094"),         // structuration / organisation
  management: u("1521737711867-e3b97375f902"),  // team collaboration mixed gender
  ecole: u("1556761175-b413da4baf72"),          // workshop / training
  seminar: u("1517245386807-bb43f82c33c4"),     // workshop scene
  pcm: u("1573164713714-d95e436ab8d6"),         // one-on-one conversation
  rise: u("1454165804606-c3d57bc86b40"),        // outdoor leadership / horizon
  abstract: u("1497366216548-37526070297c"),    // modern office aesthetic
};
